import { IResultLeadsListDAO } from '../Modules/Leads/DAO/leads.dao';
import instance from '../Services/interceptor';

export const getLeadsListAPI = async (
  params: any
): Promise<IResultLeadsListDAO[]> => {
  const startDate = params.queryKey[1];
  const endDate = params.queryKey[2];

  const { data } = await instance.get(`/lead`, {
    params: {
      From: startDate,
      To: endDate,
      IsActivated: false,
    },
  });
  return data;
};

export const getLeadsDocumentAPI = async (
  params: any
): Promise<IResultLeadsListDAO[]> => {
  const docList = params.queryKey[1];
  let imageList: any = {};
  for (const v of docList) {
    await instance
      .get(`Lead/document/${v.id}`, {
        responseType: 'blob',
      })
      .then((response: any) => {
        const objectUrl = URL.createObjectURL(response.data);
        imageList[v.documentType] = objectUrl;
      });
  }
  return imageList;
};

export const deleteLeadAPI = async (id: number) => {
  return await instance.delete(`/Lead?lead=${id}`);
};
